"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Loader, CircleCheck } from "lucide-react";
export default function StayProtected() {
  return <section data-section-id="224463" id="stay-protected" className="py-20 md:py-32 px-4 sm:px-6 dark bg-background text-foreground">
      <div className="max-w-3xl mx-auto">
        <div className="border border-border/50 rounded-2xl p-8 md:p-14 bg-card shadow-xl text-center relative overflow-hidden">
          {}
          <div className="absolute -top-24 -right-24 w-64 h-64 bg-primary/10 rounded-lg blur-3xl pointer-events-none" />
          <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-primary/10 rounded-lg blur-3xl pointer-events-none" />

          <div className="relative z-10">
            <h2 className="text-3xl md:text-4xl font-default font-bold text-foreground mb-3">
              Get Home Safety Tips & Best Deals
            </h2>
            <p className="text-muted-foreground mb-10 max-w-lg mx-auto font-default">
              No spam, only safety updates. Join our community to receive the latest home security news and exclusive offers.
            </p>

            <FormProvider formKey="stay_protected_form_home" formId="stay_protected_form_home" sectionName="RestezInforme" defaultValues={{
            first_name: "",
            email: "",
            consent: false
          }} validationRules={{
            first_name: {
              maxLength: 50
            },
            email: {
              required: true,
              pattern: "email"
            },
            consent: {
              required: true
            }
          }} submitText="Subscribe" successMessage="Thank you for joining! Your first safety update is on its way." className="max-w-md mx-auto text-left">
              <NewsletterForm />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}
function NewsletterForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center p-8 text-center space-y-4 animate-in fade-in zoom-in duration-500">
        <div className="size-12 rounded-lg bg-primary/20 flex items-center justify-center text-primary mb-2">
          <CircleCheck className="size-6" />
        </div>
        <p className="text-foreground font-default font-semibold text-lg">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-4 rounded-lg font-default">
          Sign up another email
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-5">
      <FormField control={control} name="first_name" render={({
      field
    }) => <FormItem>
            <FormLabel className="sr-only">First Name</FormLabel>
            <FormControl>
              <Input placeholder="First Name (Optional)" className="rounded-lg h-12 px-6 bg-white text-slate-900 border-border/50 focus-visible:border-primary shadow-sm" {...field} />
            </FormControl>
            <FormMessage className="px-4" />
          </FormItem>} />

      <FormField control={control} name="email" rules={{
      required: "Email address is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Invalid email address"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="sr-only">Email Address</FormLabel>
            <FormControl>
              <div className="relative group">
                <Input type="email" placeholder="your@email.com" className="rounded-lg h-14 pl-6 pr-36 bg-white text-slate-900 border-border/50 focus-visible:border-primary focus-visible:ring-primary/20 shadow-sm transition-all" {...field} />
                <Button type="submit" disabled={isSubmitting} className="absolute right-1 top-1 bottom-1 rounded-lg h-auto px-6 font-default font-bold bg-secondary text-secondary-foreground hover:bg-secondary/90 transition-transform active:scale-95">
                  {isSubmitting ? <Loader className="animate-spin size-5" /> : "Subscribe"}
                </Button>
              </div>
            </FormControl>
            <FormMessage className="px-4" />
          </FormItem>} />

      <FormField control={control} name="consent" rules={{
      required: "You must agree to the privacy policy"
    }} render={({
      field
    }) => <FormItem className="flex flex-row items-start space-x-3 space-y-0 px-2 mt-6">
            <FormControl>
              <input type="checkbox" className="mt-1 size-4 shrink-0 rounded border-border bg-white text-primary focus:ring-primary accent-primary cursor-pointer" checked={field.value} onChange={field.onChange} />
            </FormControl>
            <div className="space-y-1.5 leading-none">
              <FormLabel className="text-sm font-default font-normal text-muted-foreground cursor-pointer select-none">
                I agree to the Privacy Policy
              </FormLabel>
              <FormDescription className="text-xs font-default text-muted-foreground/60">
                You can unsubscribe at any time. We value your privacy.
              </FormDescription>
            </div>
          </FormItem>} />

      {submitError && <div className="p-4 mt-4 bg-destructive/10 border border-destructive/20 rounded-lg">
          <p className="text-destructive text-sm text-center font-default">{submitError}</p>
        </div>}
    </Form>;
}